export function propertyDataArray() {
  const courtArray = [
    {
      label: "臺灣台北地方法院",
      value: "TPD",
    },
    {
      label: "臺灣新北地方法院",
      value: "PCD",
    },
    {
      label: "臺灣士林地方法院",
      value: "SLD",
    },
    {
      label: "臺灣桃園地方法院",
      value: "TYD",
    },
    {
      label: "臺灣新竹地方法院",
      value: "SCD",
    },
    {
      label: "臺灣苗栗地方法院",
      value: "MLD",
    },
    {
      label: "臺灣臺中地方法院",
      value: "TCD",
    },
    {
      label: "臺灣南投地方法院",
      value: "NTD",
    },
    {
      label: "臺灣彰化地方法院",
      value: "CHD",
    },
    {
      label: "臺灣雲林地方法院",
      value: "ULD",
    },
    {
      label: "臺灣嘉義地方法院",
      value: "CYD",
    },
    {
      label: "臺灣臺南地方法院",
      value: "TND",
    },
    {
      label: "臺灣橋頭地方法院",
      value: "CTD",
    },
    {
      label: "臺灣高雄地方法院",
      value: "KSD",
    },
    {
      label: "臺灣屏東地方法院",
      value: "PTD",
    },
    {
      label: "臺灣臺東地方法院",
      value: "TTD",
    },
    {
      label: "臺灣花蓮地方法院",
      value: "HLD",
    },
    {
      label: "臺灣宜蘭地方法院",
      value: "ILD",
    },
    {
      label: "臺灣基隆地方法院",
      value: "KLD",
    },
    {
      label: "臺灣澎湖地方法院",
      value: "PHD",
    },
    {
      label: "福建金門地方法院",
      value: "KMD",
    },
    {
      label: "福建連江地方法院",
      value: "LCD",
    },
  ];

  const pageAmountArray = [
    "1筆",
    "2筆",
    "3筆",
    "4筆",
    "5筆",
    "6筆",
    "7筆",
    "8筆",
    "9筆",
    "10筆",
  ];

  const customerAttributesArray = [
    {
      label: "法拍",
      value: "FORECLOSURE",
    },
    {
      label: "加盟",
      value: "FRANCHISEE",
    },
    {
      label: "服務專區",
      value: "SERVICE_AREA",
    },
  ];

  const customerAttributesAllArray = [
    {
      label: "全部",
      value: null,
    },
    {
      label: "法拍",
      value: "FORECLOSURE",
    },
    {
      label: "加盟",
      value: "FRANCHISEE",
    },
    {
      label: "服務專區",
      value: "SERVICE_AREA",
    },
  ];

  const customerSourceArray = [
    {
      label: "電訪",
      value: "COLD_CALL",
    },
    {
      label: "廣告",
      value: "AD",
    },
    {
      label: "面談",
      value: "INTERVIEW",
    },
    {
      label: "親友",
      value: "RELATIVE",
    },
    {
      label: "網路",
      value: "NETWORK",
    },
    {
      label: "說明會",
      value: "SEMINAR",
    },
    {
      label: "海外",
      value: "OVERSEAS",
    },
    {
      label: "北部加盟展",
      value: "NORTH_FRANCHISE_EXHIBITION",
    },
    {
      label: "中部加盟展",
      value: "CENTRAL_FRANCHISE_EXHIBITION",
    },
    {
      label: "南部加盟展",
      value: "SOUTH_FRANCHISE_EXHIBITION",
    },
    {
      label: "會員系統",
      value: "MEMBER_SYSTEM",
    },
  ];

  const customerSourceAllArray = [
    {
      label: "全部",
      value: null,
    },
    {
      label: "電訪",
      value: "COLD_CALL",
    },
    {
      label: "廣告",
      value: "AD",
    },
    {
      label: "面談",
      value: "INTERVIEW",
    },
    {
      label: "親友",
      value: "RELATIVE",
    },
    {
      label: "網路",
      value: "NETWORK",
    },
    {
      label: "說明會",
      value: "SEMINAR",
    },
    {
      label: "海外",
      value: "OVERSEAS",
    },
    {
      label: "北部加盟展",
      value: "NORTH_FRANCHISE_EXHIBITION",
    },
    {
      label: "中部加盟展",
      value: "CENTRAL_FRANCHISE_EXHIBITION",
    },
    {
      label: "南部加盟展",
      value: "SOUTH_FRANCHISE_EXHIBITION",
    },
    {
      label: "會員系統",
      value: "MEMBER_SYSTEM",
    },
  ];

  const wishArray = [
    {
      label: "高",
      value: "HIGH",
    },
    {
      label: "中",
      value: "MIDDLE",
    },
    {
      label: "低",
      value: "LOW",
    },
  ];

  const foreclosureStatusArray = [
    {
      label: "已上課",
      value: "已上課",
    },
    {
      label: "已加盟",
      value: "已加盟",
    },
    {
      label: "課程諮詢",
      value: "課程諮詢",
    },
  ];

  const franchiseeStatusArray = [
    {
      label: "待標諮詢",
      value: "待標諮詢",
    },
    {
      label: "資訊訂閱",
      value: "資訊訂閱",
    },
    {
      label: "產權處理",
      value: "產權處理",
    },
  ];

  const foreclosureSelectAllStatusArray = [
    {
      label: "全部",
      value: null,
    },
    {
      label: "已上課",
      value: "已上課",
    },
    {
      label: "已加盟",
      value: "已加盟",
    },
    {
      label: "課程諮詢",
      value: "課程諮詢",
    },
  ];

  const franchiseeSelectAllStatusArray = [
    {
      label: "全部",
      value: null,
    },
    {
      label: "待標諮詢",
      value: "待標諮詢",
    },
    {
      label: "資訊訂閱",
      value: "資訊訂閱",
    },
    {
      label: "產權處理",
      value: "產權處理",
    },
  ];

  const assignStatusArray = [
    {
      label: "全部",
      value: null,
    },
    {
      label: "待領客戶",
      value: "WAITING_TO_CONTACT",
    },
    {
      label: "經營中",
      value: "SERVING",
    },
  ];

  const typeHouseArray = [
    {
      label: "全選",
      value: "全選",
    },
    {
      label: "土地",
      value: "土地",
    },
    {
      label: "農地",
      value: "農地",
    },
    {
      label: "透天",
      value: "透天",
    },
    {
      label: "樓店",
      value: "樓店",
    },
    {
      label: "廠房",
      value: "廠房",
    },
    {
      label: "平房",
      value: "平房",
    },
    {
      label: "華廈",
      value: "華廈",
    },
    {
      label: "公寓",
      value: "公寓",
    },
    {
      label: "套房",
      value: "套房",
    },
    {
      label: "辦公大樓",
      value: "辦公大樓",
    },
    {
      label: "別墅",
      value: "別墅",
    },
  ];

  const pointHandArray = [
    {
      label: "不限",
      value: "NO_LIMIT",
    },
    {
      label: "點交",
      value: "TRANSFER",
    },
    {
      label: "不點交",
      value: "NO_TRANSFER",
    },
  ];

  const transferArray = [
    {
      label: "點交",
      value: "1",
    },
    {
      label: "不點交",
      value: "0",
    },
    {
      label: "依公文判斷",
      value: "2",
    },
  ];

  const elevatorArray = [
    {
      label: "有",
      value: "HAS_ELEVATOR",
    },
    {
      label: "無",
      value: "NO_ELEVATOR",
    },
    {
      label: "皆可",
      value: "NO_LIMIT",
    },
  ];

  const houseStateArray = [
    { label: "自住", value: "SELF_LIVE" },
    { label: "承租", value: "LEASE" },
    { label: "空屋", value: "VACANT_HOUSE" },
    { label: "現況不明", value: "UNKNOWN" },
    { label: "第三人占用", value: "OCCUPANCY" },
  ];

  const parkingArray = [
    {
      label: "平面式",
      value: "PLANE",
    },

    {
      label: "機械式",
      value: "MECHANICAL",
    },
    {
      label: "門外",
      value: "OUTSIDE",
    },
    {
      label: "騎樓",
      value: "PEDESTRIAN_ARCADE",
    },
    {
      label: "車庫",
      value: "GARAGE",
    },
    {
      label: "無車位",
      value: "NO_PARKINGSPACE",
    },
  ];

  const adminArray = [
    {
      label: "有",
      value: "HAS_ADMINISTRATOR",
    },
    {
      label: "無",
      value: "NO_ADMINISTRATOR",
    },
    {
      label: "皆可",
      value: "NO_LIMIT",
    },
  ];

  const typeLand = [
    "透天",
    "樓店",
    "廠房",
    "平房",
    "地下室",
    "華廈",
    "公寓",
    "套房",
    "辦公",
    "含車位",
    "其他",
  ];

  const objType = [
    "透天",
    "樓店",
    "廠房",
    "平房",
    "別墅",
    "華廈",
    "公寓",
    "套房",
    "辦公",
    "土地",
    "其他",
  ];

  const BuyTypeLand = [
    "透天",
    "樓店",
    "廠房",
    "平房",
    "地下室",
    "華廈",
    "公寓",
    "套房",
    "辦公",
    "含車位",
  ];

  const auctionsArray = [
    "1拍",
    "2拍",
    "3拍",
    "應買",
    "4拍",
    "5拍",
    "6拍",
    "7拍",
    "8拍",
    "9拍",
    "10拍",
  ];

  const typeArray = [
    {
      label: "土地",
      value: "L",
    },
    {
      label: "建物",
      value: "H",
    },
  ];

  const landRightsArray = ["不分", "全部", "持分"];

  const buildRightsArray = ["不分", "全部", "持分"];

  const sourceOfTheCaseArray = [
    "不分",
    "司法院",
    "台灣金服",
    "榮服處",
    "國有財務局",
    "台灣糖業",
  ];

  const orientationArray = [
    "東",
    "南",
    "西",
    "北",
    "東南",
    "東北",
    "西南",
    "西北",
  ];

  return {
    courtArray,
    pageAmountArray,
    typeLand,
    BuyTypeLand,
    auctionsArray,
    landRightsArray,
    buildRightsArray,
    sourceOfTheCaseArray,
    typeArray,
    customerAttributesArray,
    customerAttributesAllArray,
    customerSourceArray,
    customerSourceAllArray,
    assignStatusArray,
    wishArray,
    typeHouseArray,
    pointHandArray,
    elevatorArray,
    houseStateArray,
    parkingArray,
    adminArray,
    foreclosureStatusArray,
    franchiseeStatusArray,
    foreclosureSelectAllStatusArray,
    franchiseeSelectAllStatusArray,
    transferArray,
    objType,
    orientationArray,
  };
}
